
import React from 'react';

const ButtonAccept = ({ onAcceptWithEvent = null, isDisabled = false }) => (
  <button className="btn btn-bright btn-md2 mb15 ml10" type="button" disabled={isDisabled} onClick={!isDisabled ? onAcceptWithEvent() : null}>Accept</button>
);

export default ButtonAccept;
